import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

import { Notification, NotificationId, NotificationState } from "./types";

export const name = "notifications";

const initialState: NotificationState = {
  allowConfigureResourceNotifications: {
    inprogress: true,
    success: true,
    failure: true
  },
  notifications: []
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    updateAllowConfigureResourceNotifications: (
      state,
      action: PayloadAction<
        [
          keyof NotificationState["allowConfigureResourceNotifications"],
          boolean
        ]
      >
    ) => {
      const [allowKey, bool] = action.payload;
      state.allowConfigureResourceNotifications[allowKey] = bool;
    },
    resetAllowConfigureResourceNotifications: state => {
      state.allowConfigureResourceNotifications = {
        inprogress: true,
        success: true,
        failure: true
      };
    },
    add: (state, action: PayloadAction<Notification>) => {
      state.notifications = [...state.notifications, action.payload];
    },
    flagForRemoval: (state, action: PayloadAction<NotificationId>) => {
      state.notifications = state.notifications.map(notification => ({
        ...notification,
        flaggedForRemoval:
          notification.id === action.payload
            ? true
            : notification.flaggedForRemoval
      }));
    },
    remove: (state, action: PayloadAction<NotificationId>) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    }
  }
});

export default slice.reducer;

export const {
  updateAllowConfigureResourceNotifications,
  resetAllowConfigureResourceNotifications,
  add,
  remove,
  flagForRemoval
} = slice.actions;

export const selectNotificationsState = (state: RootState) => state[name];

export const selectNotifications = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.notifications
);

export const notificationByTitleSelector = createSelector(
  selectNotifications,
  (_: RootState, params: { title: string }) => params,
  (notificationsState, { title }) =>
    notificationsState.find(notification => notification.title === title)
);

export const selectAllowConfigureResourceNotifications = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.allowConfigureResourceNotifications
);
